"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
require("../../../DOM/HTMLElement/GetHeight");
require("../../../DOM/HTMLElement/GetPosition");
require("../../../DOM/HTMLElement/GetWidth");
const RectangleUtil_1 = require("../../../DOM/HTMLElement/RelativeTo/RectangleUtil");
const Point_1 = require("../../../Utility/Point");
const Rectangle_1 = require("../../../Utility/Rectangle");
class RelativeToHelper {
    /**
     * Get the (relative) position of the given element, and include calculation of the width and height.
     */
    static getCoordinates(element, relativeTo) {
        const point = element.getPosition(relativeTo);
        return new Rectangle_1.default(point.x, point.y, element.getWidth('outer'), element.getHeight('outer'));
    }
    /**
     * Find the first parent with an overflow x/y style
     */
    static getOverflowElement(element) {
        const overflows = RelativeToHelper.OVERFLOWS;
        for (let el = element; el !== null; el = el.parentNode) {
            if (!(el instanceof HTMLElement)) {
                continue;
            }
            if (el.style && overflows.includes(el.style.overflow)) {
                return el;
            }
            const computedStyle = window.getComputedStyle(el);
            if (computedStyle && overflows.includes(computedStyle.overflow)) {
                return el;
            }
        }
        return null;
    }
    /**
     * Adjust the height of the element and the container to match the give boundaries of the viewport
     */
    static adjustHeightToViewport(element, target, rectContainer, rectVisible, alignments) {
        const rectElement = RelativeToHelper.getCoordinates(target);
        const heightAbove = rectElement.top - rectVisible.top; // height above `this`
        const heightBelow = rectVisible.top + rectVisible.height - (rectElement.top + rectElement.height); // height below `this`
        const heightAvailable = this.getAvailableHeight(heightAbove, heightBelow, alignments);
        // not enough height in the viewport, adjust container
        if (rectContainer.height > heightAvailable) {
            const insets = rectContainer.height - element.getHeight() + 1;
            // increase width to compensate for the scrollbar that's being present now
            element.style.width = (element.getWidth() + 17) + 'px';
            // make sure we show scrollbars if necessary
            element.style.overflowY = 'auto';
            // set max height, take borders into account
            element.style.maxHeight = Math.max(0, heightAvailable - insets) + 'px';
            // make sure the top element is visible
            element.scrollTo(0, 0);
            // recalculate rectangle
            rectContainer = RelativeToHelper.getCoordinates(element);
        }
        return rectContainer;
    }
    /**
     * Calculate the available visible rectangle for the given element.
     *
     * @param element the element to calculate the viewport around
     * @param detectViewport if true, will also calculate the actual viewport when a parent element has overflow style set
     */
    static getVisibleRectangle(element, detectViewport) {
        // calculate viewport of the window
        const rectViewport = new Rectangle_1.default(window.scrollX, window.scrollY, document.documentElement.clientWidth, document.documentElement.clientHeight);
        if (detectViewport === false) {
            return rectViewport;
        }
        // see if we have an element with overflow: hidden
        const overflowEl = RelativeToHelper.getOverflowElement(element);
        if (overflowEl === null) {
            return rectViewport;
        }
        // intersect overflow rectangle with window viewport
        const point = overflowEl.getPosition();
        const rectangle = rectViewport.intersect(new Rectangle_1.default(point.x, point.y, overflowEl.getWidth('inner'), overflowEl.getHeight('inner')));
        return rectangle !== null && rectangle !== void 0 ? rectangle : new Rectangle_1.default(point.x, point.y, 0, 0);
    }
    static getBestPositionWithinViewport(alignments, offset, rectContainer, rectRelativeTo, rectVisible) {
        var _a;
        let bestPoint = Point_1.default.ZERO;
        let bestAlign = null;
        let bestHeight = null;
        // determine which position of the alignments fit
        for (const align of alignments.split(/\//)) {
            const point = RectangleUtil_1.default.calculatePosition(align, offset, rectContainer, rectRelativeTo);
            // move container, and test if it fits within the current viewport
            if (rectVisible.contains(rectContainer.translate(point))) {
                bestPoint = point;
                bestAlign = align;
                break;
            }
            // if this container didn't fit inside the viewport, it still _might_ be the most available height.
            const height = (_a = rectVisible.intersect(rectContainer.translate(point))) === null || _a === void 0 ? void 0 : _a.height;
            if (height !== undefined && (bestHeight === null || height > bestHeight)) {
                bestHeight = height;
                bestPoint = point;
                bestAlign = align;
            }
        }
        return { point: bestPoint, align: bestAlign };
    }
    /**
     * Certain width and height calculations require the element to be hidden. Utility function to call a function with hiding
     * the element
     */
    static hide(element, handler) {
        const oldDisplay = element.style.display;
        element.style.display = 'none';
        const result = handler();
        element.style.display = oldDisplay;
        return result;
    }
    /**
     ** Return the max available height with taking the configured alignments into account
     */
    static getAvailableHeight(possibleHeightAbove, possibleHeightBelow, alignments) {
        const alignmentList = alignments.split(/\//);
        let heightAbove = 0;
        let heightBelow = 0;
        // Update heightAbove if vertical alignment has a T or t
        if (alignmentList.some(align => ["T", "t", "m"].includes(align.charAt(0)))) {
            heightAbove = possibleHeightAbove;
        }
        // Update heightBelow if vertical alignment has a B or b
        if (alignmentList.some(align => ["B", "b", "m"].includes(align.charAt(0)))) {
            heightBelow = possibleHeightBelow;
        }
        return Math.max(heightAbove, heightBelow);
    }
}
RelativeToHelper.OVERFLOWS = ['hidden', 'auto', 'scroll'];
exports.default = RelativeToHelper;
//# sourceMappingURL=RelativeToHelper.js.map